import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';

import { ActivityMetadataModel } from '../../../../api/api';
import { ActivityModel } from '../../Models/FlowModel';
import ActivityIcon from '../ActivityIcon';
import DisplayContentTemplate from '../DisplayContentTemplate';
import './ToolNodeHeader.scss';

type ToolNodeHeaderProps = {
	activity: ActivityModel;
	activityMetadata: ActivityMetadataModel | undefined;
	isCollapsed: boolean;
	centerTitle?: boolean;
	onToggleCollapsed?: (event: React.MouseEvent) => void;
};

export default function ToolNodeHeader({ activity, activityMetadata, isCollapsed, centerTitle = false, onToggleCollapsed }: ToolNodeHeaderProps) {
	const isCollapsible = onToggleCollapsed != null;
	const className = ['tool-node-header', centerTitle ? 'tool-node-header--center-title' : '', isCollapsible ? 'tool-node-header--collapsible' : ''].filter(Boolean).join(' ');

	return (
		<div className={className}>
			<div className="tool-node-header__title">
				<ActivityIcon activityMetadata={activityMetadata} />
				<DisplayContentTemplate
					template={activityMetadata?.displayContent}
					fallbackText={activityMetadata?.displayName ?? activity.Type}
					context={activity}
					className="tool-node-header__label"
				/>
			</div>
			{isCollapsible && (
				<IconButton className="tool-node-header__toggle" title={isCollapsed ? 'Expand' : 'Collapse'} size="small" onClick={onToggleCollapsed}>
					{isCollapsed ? <ExpandMoreIcon fontSize="inherit" /> : <ExpandLessIcon fontSize="inherit" />}
				</IconButton>
			)}
		</div>
	);
}
